

import React from "react";
import {
  Typography, Button, Container, Box, Grid, Card,
  CardContent, List, ListItem, ListItemIcon, ListItemText,
  useMediaQuery, useTheme
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Footer from "../../Common/Footer";

import screenimage from "../../Logos/screenimage.png";
import ParentTrust from "../../Logos/Elder&childcarePage/ParentsTrust.png";
import mainimage from "../../Logos/DoctorVisitPickUP/TopBanner.png";
import appointment from "../../Logos/DoctorVisitPickUP/appointment.png";
import pickup from "../../Logos/DoctorVisitPickUP/pickup.png";
import medicalhistory from "../../Logos/DoctorVisitPickUP/medicalhistory.png";
import doctor from "../../Logos/DoctorVisitPickUP/doctor.png";
import coordination from "../../Logos/DoctorVisitPickUP/coordination.png";
import accomplishment from "../../Logos/DoctorVisitPickUP/accomplishment.png";
import followup from "../../Logos/DoctorVisitPickUP/followup.png";
import DoctorVisitPickupDrop from "../../Logos/DoctorVisitPickUP/DoctorVisitPickupDrop.png";

const DoctorVisitPickup = () => {
  return (
    <Box sx={{ overflowX: "hidden" }}>
      <HeroSection />
      <OverViewSection />
      <OfferSection />
      <ScreenImageSection />
      <WhyAyuja />
      <Footer />
    </Box>
  );
};

// ─── HERO SECTION ─────────────────────────────────────────────────────────────
function HeroSection() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: { xs: "260px", sm: "310px", md: "350px" },
        backgroundImage: `url(${mainimage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        p: { xs: 2, sm: 3, md: 4 },
        color: "#fff",
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
          bgcolor: "rgba(0,0,0,0.4)",
        }}
      />
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          ml: { xs: 1, sm: 3, md: 6 },
          mt: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Typography
          variant="body1"
          sx={{
            mb: 3,
            fontSize: { xs: "26px", sm: "44px", md: "60px", lg: "72px" },
            fontFamily: '"Montserrat", sans-serif',
            lineHeight: "1.2",
            fontWeight: 600,
          }}
        >
          End-to-End Assistance<br />
          for Your Medical<br />
          Appointments
        </Typography>

      </Box>
    </Box>
  );
}

// ─── OVERVIEW SECTION ─────────────────────────────────────────────────────────
function OverViewSection() {
  return (
    <Box
      sx={{
        minHeight: { xs: "auto", md: "30vh" },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        px: { xs: 2, sm: 3, md: 4 },
        py: { xs: 3, md: 2 },
        bgcolor: "#fff",
      }}
    >
      <Container>
        <Typography
          variant="h4"
          gutterBottom
          sx={{
            textAlign: "center",
            color: "#000000",
            fontFamily: "Montserrat Alternates, sans-serif",
            fontWeight: "bold",
            fontSize: { xs: "22px", sm: "26px", md: "32px" },
          }}
        >
          Overview
        </Typography>

        <Typography
          variant="body1"
          sx={{
            maxWidth: 1000,
            fontSize: { xs: "14px", sm: "16px", md: "1.3em" },
            color: "#0161AB",
            textAlign: "center",
            mx: "auto",
            lineHeight: 1.7,
          }}
        >
          Managing doctor visits — especially for elderly patients, children, or those with chronic conditions —
          can be stressful and time-consuming. At&nbsp;
          <Box component="span" sx={{ fontSize: { xs: "1rem", md: "1.3rem" }, fontWeight: "bold" }}>
            Ayuja
          </Box>
          , we simplify the entire process by offering&nbsp;
          <Box component="span" sx={{ fontSize: { xs: "1rem", md: "1.3rem" }, fontWeight: "bold" }}>
            door-to-door transport, appointment scheduling,
          </Box>{" "}
          and medical history coordination so that you or your loved ones can focus on recovery, not logistics.
        </Typography>
      </Container>
    </Box>
  );
}

// ─── SHARED CARE CARD ─────────────────────────────────────────────────────────
function CareCard({ service }) {
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        backgroundColor: "#B3FFC4",
        border: "1.5px solid #B3FFC4",
        borderRadius: 2,
        p: { xs: 1.5, md: 2 },
        width: "100%",
        maxWidth: 320,
        minHeight: { xs: "auto", md: "18vh" },
      }}
    >
      <CardContent sx={{ flexGrow: 1, display: "flex", flexDirection: "column", p: "0 !important" }}>
        <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
          <Box
            sx={{
              width: { xs: 52, md: 62 },
              height: { xs: 52, md: 62 },
              backgroundColor: "#22577A",
              borderRadius: "50%",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mr: 2,
              flexShrink: 0,
            }}
          >
            <img
              src={service.image}
              alt={service.title}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </Box>

          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              fontFamily: '"Montserrat", sans-serif',
              color: "#000000",
              flex: 1,
              wordBreak: "break-word",
              fontSize: { xs: "16px", sm: "18px", md: "20px" },
              lineHeight: 1.3,
            }}
          >
            {service.title}
          </Typography>
        </Box>

        <Typography
          variant="body2"
          sx={{
            fontFamily: '"Montserrat", sans-serif',
            color: "#1a1a1a",
            flexGrow: 1,
            wordBreak: "break-word",
            fontSize: { xs: "15px", sm: "16px", md: "16px" },
            lineHeight: 1.7,
            px: { xs: 0.5, md: 1 },
          }}
        >
          {service.desc}
        </Typography>
      </CardContent>
    </Card>
  );
}

// ─── OFFER SECTION ────────────────────────────────────────────────────────────
const doctorServices = [
  { title: "Appointment Scheduling", desc: "We book appointments on your behalf and coordinate timings based on availability and urgency.", image: appointment },
  { title: "Pickup & Drop Services", desc: "Safe, hygienic, and punctual transport to and from hospitals or clinics.", image: pickup },
  { title: "Medical History Management", desc: "We securely store your medical history, test results, prescriptions, and treatments.", image: medicalhistory },
  { title: "Doctor Coordination", desc: "We share your medical history with doctors before visits to improve diagnosis and care.", image: doctor },
  { title: "Medication Summary Post-Visit", desc: "After your visit, we share a simple medication and next-steps summary—like a caregiver would.", image: coordination },
  { title: "Accompaniment on Visits", desc: "A trained attendant can join your visit for support and help clarify the doctor's instructions.", image: accomplishment },
  { title: "Follow-Up Care Support", desc: "Assistance in managing post-visit tasks like tests, medicine purchases, or therapy scheduling.", image: followup },
];

function OfferSection() {
  return (
    <Box sx={{ backgroundColor: "#006D77", py: 0, mb: 0, position: "relative", overflow: "hidden" }}>
      {/* Decorative image — only on large screens */}
      <Box
        component="img"
        src={DoctorVisitPickupDrop}
        alt="Doctor Visit Pickup Drop"
        sx={{
          display: { xs: "none", lg: "block" },
          position: "absolute",
          bottom: 0,
          right: 0,
          width: "400px",
          height: "auto",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      <Container maxWidth="lg" sx={{ py: 3, position: "relative", zIndex: 1 }}>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{
            fontWeight: "bold",
            fontFamily: '"Montserrat", sans-serif',
            color: "#B3FFC4",
            fontSize: { xs: "22px", sm: "26px", md: "30px" },
          }}
        >
          What We Offer
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mb: 3, color: "#B3FFC4", lineHeight: 1.6,
            textAlign: "center", fontSize: { xs: "13px", md: "16px" },
          }}
        >
          Stress-Free Medical Visits from Start to Finish
        </Typography>

        <Grid container spacing={{ xs: 2, sm: 2.5, md: 3 }} justifyContent="center">
          {doctorServices.map((service, idx) => (
            <Grid item xs={12} sm={6} md={4} key={idx} sx={{ display: "flex", justifyContent: "center" }}>
              <CareCard service={service} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

// ─── SCREEN DIVIDER ───────────────────────────────────────────────────────────
function ScreenImageSection() {
  return (
    <Box
      component="img"
      src={screenimage}
      alt="divider"
      sx={{
        width: "100%",
        height: { xs: "6vh", md: "10vh" },
        objectFit: "cover",
        borderRadius: "0px 0px 100px 0px",
        display: "block",
      }}
    />
  );
}

// ─── WHY AYUJA ────────────────────────────────────────────────────────────────
function WhyAyuja() {
  const trustPoints = [
    "Coordination with doctors for smoother, more informed consultations",
    "Safe and supportive environment for elderly, children, and post-op patients",
    "Peace of mind for family members — we act as an extended support system",
    "End-to-end service from scheduling to transport to care follow-up",
  ];

  return (
 <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "stretch",
        backgroundColor: "#006699",
        color: "white",
        minHeight: { xs: "auto", md: "400px" },
        overflow: "hidden",
      }}
    >
      {/* Left: Text Section */}

      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",  
          alignItems: "center",    
          py: { xs: 4, md: 6 },
          px: 2,                  
          order: { xs: 2, md: 1 },
          textAlign: "center",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",justifyContent: "center", alignItems: "center",   
            mb: { xs: 2, md: 3 },
            fontSize: { xs: "20px", sm: "24px", md: "28px", lg: "32px" },
          }}
        >
          Why Choose Ayuja for Doctor Visits & Transport?
        </Typography>

        <List sx={{ p: 0 }}>
          {trustPoints.map((text, i) => (
            <ListItem key={i} sx={{ py: { xs: 0.8, md: 1.2 }, px: 0, alignItems: "flex-start" }}>
              <ListItemIcon sx={{ minWidth: 40, mt: 0.3 }}>
                <CheckCircleIcon sx={{ color: "#4CAF50", fontSize: { xs: "22px", md: "26px" } }} />
              </ListItemIcon>
              <ListItemText
                primary={text}
                primaryTypographyProps={{
                  fontSize: { xs: "14px", sm: "16px", md: "19px" },
                  fontWeight: "400",
                  color: "white",
                  lineHeight: 1.5,
                }}
              />
            </ListItem>
          ))}
        </List>
      </Box>

 {/* Right: Image — full height cover */}
      <Box
        sx={{
          // On mobile: normal image below text
          // On desktop: fixed width panel, image covers it fully
          width: { xs: "100%", md: "35%", lg: "32%" },
          minHeight: { xs: "260px", md: "100%" },
          order: { xs: 1, md: 2 },
          flexShrink: 0,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <Box
          component="img"
          src={ParentTrust}
          alt="Parents and Child"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center top",
            display: "block",
            // On mobile keep natural aspect ratio
            minHeight: { xs: "260px", md: "400px" },
          }}
        />
      </Box>
    </Box>
  );
}

export default DoctorVisitPickup;
